import {
  AbstractControl,
  FormControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';

export class ProcessStructure {
  id?: number;
  group?: number;
  step: number = 1;
  name?: string;
  description?: string;
  type: string = '';
  isSendCommand: boolean = false;
  isAnalyticResponseCommand: boolean = false;
  isAnalyticPosition: boolean = false;
  analyticPositionIfHasEvent: boolean = false;
  analyticPositionEvent?: string;
  analyticPositionEventException?: string;
  analyticPositionField?: string;
  analyticPositionValueTypeExpected?: string;
  analyticPositionValueExpected?: string;
  analyticPositionLogic?: string;
  analyticIsSplitValue?: string;
  analyticSplitValue?: string;
  analyticValueIndex?: number;
  analyticCaseSensitive?: boolean;
  analyticNextStepIfTrue?: number;
  analyticNextStepIfFalse?: number;
  analyticKeepRequestCommandIdAfterCheck?: boolean = false;
  commandTypeId?: number;
  hasCommandParam?: boolean;
  commandParam?: string;
  commandTimeOut?: number;
  waitBeforeBeginStep?: number = 0;
  createdDateTime?: Date;
  userCreatedId?: number;
  status?: string;
  updateStatusDateTime?: string;
  stepDidConfig: boolean = false;

  constructor() {}

  clone(other: ProcessStructure): void {
    let k: keyof ProcessStructure;
    for (k in other) {
      const v = other[k];
      (this[k] as typeof v) = v;
    }
  }

  fromGroup(form: FormGroup) {
    this.step = form.get('step')?.value;
    this.name = form.get('name')?.value;
    this.description = form.get('description')?.value;
    this.type = form.get('type')?.value;
    this.isSendCommand = form.get('isSendCommand')?.value;
    this.isAnalyticResponseCommand = form.get(
      'isAnalyticResponseCommand'
    )?.value;
    this.isAnalyticPosition = form.get('isAnalyticPosition')?.value;
    //this. analyticPositionIfHasEvent= new FormGroup("");
    //this. analyticPositionEvent= new FormGroup("");
    //this. analyticPositionEventException= new FormGroup("");
    //this. analyticPositionField= new FormGroup("");
    this.analyticPositionValueTypeExpected = form.get(
      'analyticPositionValueTypeExpected'
    )?.value;
    this.analyticPositionValueExpected = form.get(
      'analyticPositionValueExpected'
    )?.value;
    this.analyticPositionLogic = form.get('analyticPositionLogic')?.value;
    this.analyticIsSplitValue = form.get('analyticIsSplitValue')?.value;
    this.analyticSplitValue = form.get('analyticSplitValue')?.value;
    this.analyticValueIndex = form.get('analyticValueIndex')?.value;
    this.analyticCaseSensitive = form.get('analyticCaseSensitive')?.value;
    this.analyticNextStepIfTrue = form.get('analyticNextStepIfTrue')?.value;
    this.analyticNextStepIfFalse = form.get('analyticNextStepIfFalse')?.value;
    this.analyticKeepRequestCommandIdAfterCheck = form.get(
      'analyticKeepRequestCommandIdAfterCheck'
    )?.value;
    this.waitBeforeBeginStep = form.get('waitBeforeBeginStep')?.value;
    this.commandTypeId = form.get('commandTypeId')?.value;
    this.hasCommandParam = form.get('hasCommandParam')?.value;
    this.commandParam = form.get('commandParam')?.value;
    this.commandTimeOut = form.get('commandTimeOut')?.value;
  }

  toFromGroup(): FormGroup {
    var formGroup = new FormGroup(
      {
        step: new FormControl(this.step, [Validators.required]),
        name: new FormControl(this.name),
        description: new FormControl(this.description, [Validators.required]),
        type: new FormControl(this.type),
        isSendCommand: new FormControl(this.isSendCommand, [
          Validators.required,
        ]),
        isAnalyticResponseCommand: new FormControl(
          this.isAnalyticResponseCommand,
          [Validators.required]
        ),
        isAnalyticPosition: new FormControl(this.isAnalyticPosition, [
          Validators.required,
        ]),
        // analyticPositionIfHasEvent: new FormGroup(""),
        // analyticPositionEvent: new FormGroup(""),
        // analyticPositionEventException: new FormGroup(""),
        // analyticPositionField: new FormGroup(""),
        analyticPositionValueTypeExpected: new FormControl(
          this.analyticPositionValueTypeExpected
        ),
        analyticPositionValueExpected: new FormControl(
          this.analyticPositionValueExpected
        ),
        analyticPositionLogic: new FormControl(this.analyticPositionLogic),
        analyticIsSplitValue: new FormControl(this.analyticIsSplitValue),
        analyticSplitValue: new FormControl(this.analyticSplitValue),
        analyticValueIndex: new FormControl(this.analyticValueIndex),
        analyticCaseSensitive: new FormControl(this.analyticCaseSensitive),
        analyticNextStepIfTrue: new FormControl(this.analyticNextStepIfTrue),
        analyticNextStepIfFalse: new FormControl(this.analyticNextStepIfFalse),
        analyticKeepRequestCommandIdAfterCheck: new FormControl(
          this.analyticKeepRequestCommandIdAfterCheck
        ),
        waitBeforeBeginStep: new FormControl(this.waitBeforeBeginStep),
        commandTypeId: new FormControl(this.commandTypeId),
        hasCommandParam: new FormControl(this.hasCommandParam),
        commandParam: new FormControl(this.commandParam),
        commandTimeOut: new FormControl(this.commandTimeOut),
        stepDidConfig: new FormControl(false),
      },
      { validators: validatorFn() }
    );

    //  let keys = Object.keys(formGroup.value)
    //  keys.forEach((key)=>{
    //    formGroup.get(key)?.valueChanges.subscribe(()=>{
    //      formGroup.updateValueAndValidity()
    //    })
    //  })

    return formGroup;
  }
}

export function responseCommandValidatorFn(): ValidatorFn {
  return (formGroup: AbstractControl): ValidationErrors | null => {
    const type: String = new String(formGroup.get('type'));
    const analyticNextStepIfTrue = formGroup.get('analyticNextStepIfTrue');
    const analyticNextStepIfFalse = formGroup.get('analyticNextStepIfFalse');
    if (type.includes('RESPOSTA_COMANDO')) {
      if (analyticNextStepIfTrue?.value && !analyticNextStepIfFalse?.value) {
        return { message: 'Incluir próxima etapa', error: true };
      }
    }
    return null;
  };
}

function validatorFn(): ValidatorFn {
  return (formGroup: AbstractControl): ValidationErrors | null => {
    let message: string[] = [];
    let error: boolean[] = [];

    if (!formGroup.get('description')?.value) {
      message.push('Preencha a descrição da etapa!');
      error.push(true);
    }
    if (
      !formGroup.get('isSendCommand')?.value &&
      !formGroup.get('isAnalyticResponseCommand')?.value
    ) {
      message.push('Selecione pelo menos uma ação');
      error.push(true);
    }

    if (formGroup.get('waitBeforeBeginStep')?.value == undefined) {
      message.push(
        'Insira o tempo que deve esperar para realizar o próximo passo'
      );
      error.push(true);
    }

    if (formGroup.get('isSendCommand')?.value) {
      if (!formGroup.get('commandTypeId')?.value) {
        message.push('Comando - Selecione um comando');
        error.push(true);
      }
      if (!formGroup.get('commandTimeOut')?.value) {
        message.push('Comando - Insira o valor de timeout');
        error.push(true);
      }
      if (formGroup.get('hasCommandParam')?.value) {
        if (
          !formGroup.get('commandParam')?.value ||
          formGroup.get('commandParam')?.value == ''
        ) {
          message.push('Comando - O comando precisa de parâmetro');
          error.push(true);
        }
      }
    }
    if (formGroup.get('isAnalyticResponseCommand')?.value) {
      if (!formGroup.get('analyticPositionValueExpected')?.value) {
        message.push('Resposta comando - Insira um valor esperado');
        error.push(true);
      }
      if (!formGroup.get('analyticPositionLogic')?.value) {
        message.push('Resposta comando - Selecione uma lógica');
        error.push(true);
      }
      if (formGroup.get('analyticIsSplitValue')?.value) {
        if (!formGroup.get('analyticSplitValue')?.value) {
          message.push('Resposta comando - Insira o que vai quebrar o pacote');
          error.push(true);
        }
        if (!formGroup.get('analyticValueIndex')?.value) {
          message.push(
            'Resposta comando - Insira a partir de qual index deve ser analisado (começando no 0)'
          );
          error.push(true);
        }
      }
      if (!formGroup.get('analyticNextStepIfTrue')?.value) {
        message.push(
          'Resposta comando - Insira para qual etapa ir se for verdadeiro'
        );
        error.push(true);
      }
      if (!formGroup.get('analyticNextStepIfFalse')?.value) {
        message.push(
          'Resposta comando - Insira para qual etapa ir se for falso'
        );
        error.push(true);
      }
    }

    if (error.includes(true)) {
      return {
        message: message,
        error: true,
      };
    } else {
      return null;
    }
  };
}

export class ProcessItem {
  id!: number;
  serial!: string;
  processStructureGroup!: number;
  currentStep!: number;
  state!: string;
  requestCommandId!: number;
  requestCommandDateTime!: Date;
  commandAttempts!: number;
  qtdRework!: number;
  lastPosition!: Date;
  isActive!: boolean;
  updateDateTime!: Date;
  createDateTime!: Date;
  userCreatedId!: number;
}

export class ProcessItemFilter {
  serial: { type: string; value: any };
  processStructureGroup: { type: string; value: any };
  currentStep: { type: string; value: any };
  state: { type: string; value: any };
  commandAttempts: { type: string; value: any };
  qtdRework: { type: string; value: any };
  // lastPosition: { type: string; value: any };
  // isActive: { type: string; value: any };

  constructor() {
    this.serial = { type: 'text', value: '' };
    this.processStructureGroup = { type: 'text', value: '' };
    this.currentStep = { type: 'number', value: '' };
    this.state = { type: 'text', value: '' };
    this.commandAttempts = { type: 'number', value: 0 };
    this.qtdRework = { type: 'number', value: 0 };
    // this.lastPosition = { type: 'date', value: new Date() };
    // this.isActive = { type: 'checkbox', value: false };
  }
}
